__turbopack_context__.v({
  "actions": "MarketplaceAppModal-module__ph2sbW__actions",
  "appInfo": "MarketplaceAppModal-module__ph2sbW__appInfo",
  "appLogo": "MarketplaceAppModal-module__ph2sbW__appLogo",
  "appTitle": "MarketplaceAppModal-module__ph2sbW__appTitle",
  "author": "MarketplaceAppModal-module__ph2sbW__author",
  "bottomSection": "MarketplaceAppModal-module__ph2sbW__bottomSection",
  "categories": "MarketplaceAppModal-module__ph2sbW__categories",
  "category": "MarketplaceAppModal-module__ph2sbW__category",
  "description": "MarketplaceAppModal-module__ph2sbW__description",
  "externalIcon": "MarketplaceAppModal-module__ph2sbW__externalIcon",
  "iconButton": "MarketplaceAppModal-module__ph2sbW__iconButton",
  "launchButton": "MarketplaceAppModal-module__ph2sbW__launchButton",
  "links": "MarketplaceAppModal-module__ph2sbW__links",
  "logoPlaceholder": "MarketplaceAppModal-module__ph2sbW__logoPlaceholder",
  "modalContent": "MarketplaceAppModal-module__ph2sbW__modalContent",
  "siteLink": "MarketplaceAppModal-module__ph2sbW__siteLink",
  "socialIcon": "MarketplaceAppModal-module__ph2sbW__socialIcon",
  "titleRow": "MarketplaceAppModal-module__ph2sbW__titleRow",
  "topSection": "MarketplaceAppModal-module__ph2sbW__topSection",
});
